export enum ModalTitleIcons {
    DEFAULT = 'DEFAULT',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    INFO = 'INFO',
}
